import type { Cfg } from './use-settings-state';

export const DEFAULTS: Cfg = {
  payment_cycle_days: 7,
  payment_threshold: 100,
  payment_day_of_week: 1,
  minimum_payout_banned: 3,
  minimum_leads_count: 100,
  minimum_leads_period: 'weekly',
  bonus_period: 'weekly',
  bonus_1: 150,
  bonus_2: 100,
  bonus_3: 50,
  ranking_period: 'weekly',
  weekly_goal: 10000,
  total_goal: 100000,
  group_bonus_amount: 33,
  daily_minimum_leads: 33,
  top_tier_threshold: 66,
  top_tier_days_required: 5,
  pre_ban_failed_days_threshold: 3,
  pre_ban_grace_days: 2,
  daily_first_to_x_enabled: false,
  daily_first_to_x_threshold: 0,
  daily_first_to_x_amount_usd: 0,
  weekly_first_to_x_enabled: false,
  weekly_first_to_x_threshold: 0,
  weekly_first_to_x_amount_usd: 0,
  monthly_first_to_x_enabled: false,
  monthly_first_to_x_threshold: 0,
  monthly_first_to_x_amount_usd: 0,
};
